import { Component } from 'preact'
import Markdown from 'preact-markdown'

import s from './plan-section.sass'
import CollapsibleSection from '../collapsible-section'
import GridSelect from '../grid-select'
import SelectGroup, { TYPE_RADIO } from '../select-group'
import { checkoutPaymentTimeSelection } from '../../../helpers/analytics'

export default class PlanSection extends Component {
  handleOnInput (value) {
    this.props.onInput(value)
    checkoutPaymentTimeSelection(value === 'true')
  }

  render ({
    onInput,
    title,
    description,
    inputs,
    ...rest
  }) {
    return (
      <CollapsibleSection
        className={s.planSection}
        {...rest}
      >
        <div className={s.content}>
          <h2>{title}</h2>
          <SelectGroup
            className={s.gridSelect}
            type={TYPE_RADIO}
            onChange={(value) => this.handleOnInput(value)}
          >
            {inputs.map((input, key) => <GridSelect key={key} {...input} />)}
          </SelectGroup>
          <div className={s.description}><Markdown markdown={description || ''} /></div>
        </div>
      </CollapsibleSection>
    )
  }
}



// WEBPACK FOOTER //
// ./components/signup-flow/step-payment/plan-section.js